import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';

const NotFoundPage = () => {
  return (
    <PageLayout title="Page Not Found">
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Page not found</h1>
          <p className="text-gray-600 mb-8">The page you are looking for doesn't exist or has been moved.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/" className="px-4 py-3 bg-white border rounded hover:bg-gray-50">Home</Link>
            <Link to="/posts" className="px-4 py-3 bg-white border rounded hover:bg-gray-50">Posts</Link>
            <Link to="/properties" className="px-4 py-3 bg-white border rounded hover:bg-gray-50">Properties</Link>
            <Link to="/businesses" className="px-4 py-3 bg-white border rounded hover:bg-gray-50">Businesses</Link>
            <Link to="/events" className="px-4 py-3 bg-white border rounded hover:bg-gray-50">Events</Link>
            <Link to="/about" className="px-4 py-3 bg-white border rounded hover:bg-gray-50">About</Link>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default NotFoundPage;


